import * as React from 'react'
import {
  InitPricesParams,
  ResetPricesParams,
  SelectFilterParams,
  SelectRangeParams,
} from '@/scopes/prices/domain/types'

interface PricesActionsContextType {
  initPrices: (params: InitPricesParams) => Promise<void>
  initPriceTable: () => Promise<void>
  selectFilterMonth: (month: string, callback: (startDate: Date) => void) => Promise<void>
  selectFilter: (params: SelectFilterParams) => Promise<void>
  selectRange: (params: SelectRangeParams) => Promise<{ minDatePrices: string, maxDatePrices: string }>
  selectPrice: (priceId: string | null) => Promise<void>
  selectRoom: (roomNumber: string, roomId: string | null) => Promise<void>
  setOutboundRouteId: (routeId: string | null) => Promise<void>
  setInboundRouteId: (routeId: string | null) => Promise<void>
  setOutboundBusId: (busId: string | null) => Promise<void>
  setInboundBusId: (busId: string | null) => Promise<void>
  resetPrices: (params: ResetPricesParams) => Promise<void>
}

export const PricesActionsContext = React.createContext<PricesActionsContextType>({
  initPrices: async () => {},
  initPriceTable: async () => {},
  selectFilterMonth: async () => {},
  selectFilter: async () => {},
  selectRange: async () => ({ minDatePrices: '', maxDatePrices: '' }),
  selectPrice: async () => {},
  selectRoom: async () => {},
  setOutboundRouteId: async () => {},
  setInboundRouteId: async () => {},
  setOutboundBusId: async () => {},
  setInboundBusId: async () => {},
  resetPrices: async () => {},
})
